export default __webpack_public_path__ + "static/media/charity_partner.01db844f.png";